import { useMutation } from '@tanstack/react-query';

type CompanyFileDeleteRequest = {
  companyId: number;
  fileId: number;
};

export default function useDeleteCompanyFile() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ companyId, fileId }: CompanyFileDeleteRequest) => {
      const response = await fetch(`/agent/api/companies/${companyId}/files`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ id: fileId }),
      });
      const data = await response.json();
      return data;
    },
  });
}
